export const parseCurrencyString = (input: string) => {
  if (input) {
    const currencyMatch = input?.match(/^[^\d.-]+/);
    const symbolOrCode = currencyMatch ? currencyMatch[0]?.trim() : '';
    const cleanedNumber = input?.replace(/[^0-9.-]+/g, '');
    const parsedAmount = parseFloat(cleanedNumber);

    return {
      symbolOrCode,
      amount: new Intl.NumberFormat('en-US').format(parsedAmount)
    };
  } else {
    return {
      amount: '-',
    };
  }
};

export const formatMileage = (input: string | number) => {
  if (input == null) return '-';

  const number = typeof input === 'string' ? parseFloat(input) : input;

  if (isNaN(number)) return '-';

  return number.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
